import React, { useState, useEffect, useRef } from 'react';
import { Link, useParams, useNavigate } from "react-router-dom";
import {getProjectDetails, getProjectTitles, client} from '../../utils/sanity/sanity';
import imageUrlBuilder from '@sanity/image-url'

import ContactSection from '../../components/ContactSection';

import { FaLongArrowAltLeft } from "react-icons/fa"
import { FaLongArrowAltRight } from "react-icons/fa"

const builder = imageUrlBuilder(client)

function urlFor(source) {
  return builder.image(source)
}

let projectDetail = null


function ProjectDescription() {
  const navigate = useNavigate();

  const [projectDetails, setProjectDetails] = useState(null);
  const [projectsLength, setProjectsLength] = useState(0)
  const titlesRef = useRef([]);

  const { projectId } = useParams();

  const currentProject = JSON.parse(projectId);
  const prev = ((currentProject - 2) + projectsLength) % projectsLength + 1;
  const next = (currentProject % projectsLength) + 1;

  const previousTitle = titlesRef.current[(currentProject - 2 + projectsLength) % projectsLength];
  const nextTitle = titlesRef.current[currentProject % projectsLength];

  const goToPrevProject = () => {
    navigate(`/portfolio/project_description/${prev}`);
  };
  const goToNextProject = () => {
    navigate(`/portfolio/project_description/${next}`);
  };

  useEffect(() => {
    async function fetchData() {
      const projectDetailsData = await getProjectDetails();
      const projectTitles = await getProjectTitles();
      titlesRef.current = projectTitles;
      setProjectDetails(projectDetailsData);
      setProjectsLength(projectDetailsData.length)
      
    }
    fetchData();
  }, []);


  if (projectDetails) {
    const sanity = projectDetails;
    projectDetail = [sanity.find( item => item.details.id === JSON.stringify(currentProject))]
  }

  return (
    <>
    {projectDetail && projectDetail.map((detail) => (
   
          <main className='max-w-screen min-h-screen mx3 px-6 xl:px-40 md:px-10' key={detail.details.id}>
            <picture className='w-full my-auto px-20'>
                <img src={urlFor(detail.details.projectImage)} alt="Project images" className='block w-full h-auto mx-auto'/>
            </picture>
            <div className='h-1/4 flex xl:flex-row flex-col w-full pb-6 xl:pb-20 md:pb-16 my-5 xl:my-20 justify-between'> 
              <div className='h-full py-4 mx-0 xl:mx-10 w-full bg-white border-y border-gray-400 pt-5 md:pt-14 background-color flex-col'>
                <h1 className='heading-font text-2xl lg:text-4xl md:text-3xl font-bold w-full'>
                  {detail.details.title}
                </h1 >
                <p className='main-font text-base pt-7 pb-2s xl:pb-6 mb-4 leading-7 font-normal w-full'>
                  {detail.details.task}
                </p>
              </div>
              <div className='w-full h-full max-w-2xl pl-0 xl:pl-20 pt-4 xl:pt-0 md:pt-10'>
                <h3 className='heading-font text-2xl lg:text-4xl md:text-3xl font-normal'>
                  Project Background
                </h3>
                <p className='main-font text-base pt-2 md:pt-7 pb-2 xl:pb-6 leading-7 font-normal text-justify'>
                  {detail.details.background}
                </p>
              </div>
            </div>
            <div className='w-full mb-10 xl:mb-36 md:mb-14 h-auto flex flex-row border-t border-b border-gray-300'>
              <div className=' w-full h-full flex justify-start items-end text-left '>
                <Link
                  to={`/portfolio/project_description/${prev}`}
                  className='h-full w-auto flex flex-col hover:bg-emerald-200 py-4'
                  onClick={goToPrevProject}>
                  <div className='flex self-start py-1'>
                    <FaLongArrowAltLeft className='text-2xl text-gray-600' />
                  </div>
                  <p className='heading-font text-xl md:text-3xl text-gray-900 pb-0'>
                    {previousTitle}
                  </p>
                  <p className='main-font py-1 text-sm md:text-base'>
                    Previous Project
                  </p>
                </Link>
              </div>
              <div className='flex-auto h-auto'>
                <div className='h-full w-px bg-gray-300 mx-8:block'></div>
              </div>
              <div className=' w-full h-full flex justify-end items-end text-right '>
                <Link
                  to={`/portfolio/project_description/${next}`}
                  className='h-full w-auto flex flex-col hover:bg-emerald-200 py-4'
                  onClick={goToNextProject}>
                  <div className='flex self-end py-1'>
                    <FaLongArrowAltRight className='text-2xl text-gray-600' />
                  </div>
                  <p className='heading-font text-xl md:text-3xl text-gray-900 pb-0'>
                    {nextTitle}
                  </p>
                  <p className='main-font py-1 text-sm md:text-base text-right' style={{textAlign:"right"}}>
                    Next Project
                  </p>
                </Link>
              </div>
            </div>
            <ContactSection/>
          </main>
       
      ))}
    </>
  )
}

export default ProjectDescription